module.exports = __webpack_public_path__ + "static/media/06.daa0c68e.png";